import React from 'react';
import { ChevronRightIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { ROUTE } from '../data/content';
export function RouteSection() {
  return <section aria-labelledby="ruta" className="border-y-2 border-volt/25 bg-electric" data-id="element-185" data-mp="9cjoorgb0vfb">
      <div className="mx-auto max-w-page px-3 py-7 text-center sm:px-6 sm:py-8" data-id="element-186" data-mp="5ay38hppf8ti">
        <Reveal data-id="element-187" data-mp="58vdlysgrhpb">
          <h2 id="ruta" className="font-display text-lg uppercase leading-tight text-white sm:text-2xl lg:text-3xl" data-id="element-188" data-mp="bv6rlnsiax5">
            ⏱️ Menos búsqueda. Más aprendizaje con dirección.
          </h2>
          <p className="mx-auto mt-2 max-w-2xl text-[0.8rem] font-semibold leading-snug text-white/90 sm:text-sm" data-id="element-189" data-mp="3mibgjd544k2w">
            En lugar de preguntarte qué estudiar después, avanzas por una ruta
            de 6 tomos:
          </p>
        </Reveal>

        <Reveal delay={0.05} className="mx-auto mt-3 flex max-w-4xl flex-wrap items-center justify-center gap-1.5" data-id="element-190" data-mp="1kpm25dn3x4v9">
          {ROUTE.map((step, i) => <React.Fragment key={step} data-id="element-191" data-mp="mytzgrnhxl80" data-mpi={i}>
              <span className="rounded-md bg-carbon px-2.5 py-1.5 font-display text-[0.7rem] uppercase tracking-wide text-volt sm:px-3 sm:text-sm" data-id="element-192" data-mp="ryyl0w39h653">
                {step}
              </span>
              {i < ROUTE.length - 1 && <ChevronRightIcon size={14} aria-hidden="true" className="text-volt" strokeWidth={3} data-id="element-193" data-mp="i1tukk2duoih" />}
            </React.Fragment>)}
        </Reveal>
      </div>
    </section>;
}